<template>
  <header class="header">
    <slot />
  </header>
</template>

<script>
export default {
  name: 'PartnerHeader',
};
</script>

<style lang="scss" scoped>
.header {
  background: $primary no-repeat url(/img/partner_welcome/world.png) 50%;
  background-size: contain;
  box-shadow: inset 0 0 10px -5px;
  padding: 72px 0;
}
</style>
